import { render, staticRenderFns } from "./ProductInfoRegistTable.vue?vue&type=template&id=79109e48&scoped=true&"
import script from "./ProductInfoRegistTable.vue?vue&type=script&lang=js&"
export * from "./ProductInfoRegistTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoRegistTable.vue?vue&type=style&index=0&id=79109e48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79109e48",
  null
  
)

export default component.exports